<div class="plan-ride-button-container">
  <div #rideTypeSelector class="ride-type-selector" [hidden]="!isRideTypeSelectorShowing">
    <div class="ride-type-selector-open">
      <button
        id="offRoadRoute"
        class="button primary-button helper-no-bottom-border"
        type="button"
        rdxAnalytics="Off-Road"
        (click)="goToOrvRidePlanning()"
      >
        <svg-icon src="/assets/icons/orv.svg" alt="offroad" i18n-alt />
        <ng-container i18n>Off-Road</ng-container>
      </button>
      <button
        id="snowmobileRoute"
        class="button primary-button"
        type="button"
        rdxAnalytics="Snowmobile"
        (click)="goToSnowRidePlanning()"
      >
        <svg-icon src="/assets/icons/snow.svg" alt="snowmobile" i18n-alt />
        <ng-container i18n>Snowmobile</ng-container>
      </button>
    </div>
  </div>
  <button
    id="planARouteHere"
    class="button secondary-button plan-ride-button"
    type="button"
    rdxAnalytics="Plan Ride"
    [ngClass]="{ 'plan-ride-button-icon': showPlanRideIcon }"
    [rdxAnalyticsData]="entityType"
    (click)="openPlanARide($event)"
  >
    @if (showPlanRideIcon) {
      <svg-icon src="/assets/icons/routes.svg" alt="Plan Rides" i18n-alt />
    }
    <ng-container i18n>Plan Ride</ng-container>
  </button>
</div>
